import tenant from "@/helpers/tenant";
import clipboard from "@/helpers/clipboard";

export default {

    data(){
        return {
            helpers: {
                clipboard,
                tenant,
            }
        };
    }

 };
